export enum ExportEventType {
    Download = 'DOWNLOAD',
    Consultation = 'CONSULTATION'
}
